import type { ReactElement } from "react";
import { cloneElement } from "react";
import { SectionContext } from "./SectionContext.tsx";
import { useImpressionTracking } from "./use-impression-tracking.ts";

export type SectionProps = {
  /**
   * Optional component to render instead of a div. If provided, the component
   * must accept a `ref` prop.
   */
  as?: ReactElement<{
    ref?: React.Ref<HTMLElement>;
    className?: string;
    children?: React.ReactNode;
    "data-section-name"?: string;
  }>;
  /**
   * The name of the current section. (Used for analytics.)
   */
  name: string;
  className?: string;
  children: React.ReactNode | React.ReactNode[];
};

export const Section = ({
  className,
  as = <div className={className} />,
  name,
  children,
}: SectionProps) => {
  const ref = useImpressionTracking("SECTION_VIEW", {
    properties: { section: name },
  });

  return (
    <SectionContext name={name}>
      {cloneElement(as, {
        className,
        ref,
        children,
        "data-section-name": name,
      })}
    </SectionContext>
  );
};
